import { render, staticRenderFns } from "./DirectorioForm.vue?vue&type=template&id=158e76a4&"
import script from "./DirectorioForm.vue?vue&type=script&lang=js&"
export * from "./DirectorioForm.vue?vue&type=script&lang=js&"
import style0 from "./DirectorioForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports